import React, { useState, useEffect} from "react";
import AsideInfoBar from "../common/AsideInfoBar";
import MobileNav from "../common/MobileNav/MobileNav";
import { Link, useNavigate} from "react-router-dom";
import { Button, message, Modal } from 'antd';

const ConsultancyHeader = () => {
  const navigate = useNavigate();
  const [isLogined, setIsLogined] = useState(false);
  const [confirmSignOut, setConfirmSignOut] = useState(false);
  const [schoolDetails, setSchoolDetails] = useState({});
  console.log("School details in header", schoolDetails)

  const ConsultancyAsideData = {
    logo: "images/logo-header.png",
    href: "/consultancy",
  };

  // Sticky Header
  window.onscroll = () => {
    if (
      document.body.scrollTop >= 50 ||
      document.documentElement.scrollTop >= 50
    ) {
      document.querySelector("header")?.classList.add("sticky");
    } else {
      document.querySelector("header")?.classList.remove("sticky");
    }
  };

  const getSchoolData = () => {
    const schoolDetails = JSON.parse(localStorage.getItem("school_details"));
    setSchoolDetails(schoolDetails);
  }

      // 1. Initial load: Check storage when the component first mounts
      useEffect(() => {
        getSchoolData();
      }, []);

      // 2. Listen for changes: Your existing listener for events
      useEffect(() => {
        const handleStorageChange = () => {
          getSchoolData();
        };
        window.addEventListener("storage_updated", handleStorageChange);
        window.addEventListener("storage", handleStorageChange);

        return () => {
          window.removeEventListener("storage_updated", handleStorageChange);
          window.removeEventListener("storage", handleStorageChange);
        };
      }, []);

  useEffect(() => {
    if(schoolDetails?.orgId){
      setIsLogined(true);
    } else {
      setIsLogined(false)
    }
  }, [schoolDetails])

  const showModal = () => {
    setConfirmSignOut(true);
  };
  const handleOk = () => {
    localStorage.removeItem("school_details");
    message.success("Sign out Succesfully");
    getSchoolData();
    setConfirmSignOut(false);
  };
  const handleCancel = () => {
    setConfirmSignOut(false);
  };

  const handleSignOut = () => {
    showModal();
  }

  // Aside info bar
  const [isAdd, setAdd] = useState("false");
  const handleAddCss = () => {
    setAdd(!isAdd);
  };

  // Search width increase
  const [isActive, setActive] = useState("true");

  const handleToggle = () => {
    setActive(!isActive);
  };

  return (
    <>
      <header className="main-header two">
        {/* <!-- Header Top --> */}
        <div className="header-top">
          <div className="container">
            <div className="d-flex justify-content-between align-items-center flex-wrap">
              {/* <!-- Left Box --> */}
              <div className="left-box d-flex align-items-center header-top-social">
                {/* <!-- Social Box --> */}
                <ul className="social-box">
                  <li>
                    <a
                      href="https://www.facebook.com/"
                      className="fa fa-facebook-f"
                    ></a>
                  </li>
                  <li>
                    <a
                      href="https://www.instagram.com/"
                      className="fa fa-instagram"
                    ></a>
                  </li>
                  <li>
                    <a
                      href="https://www.twitter.com/"
                      className="fa fa-twitter"
                    ></a>
                  </li>
                  <li>
                    <a
                      href="https://www.linkedin.com/"
                      className="fa fa-linkedin"
                    ></a>
                  </li>
                </ul>
              </div>

              {/* <!-- Right Box --> */}
              <div className="right-box d-flex align-items-center header-top-main">
                <ul className="info-list">
                  <li>
                    <a href="mailto:stusphere@gmail.com">
                      <span className="icon fa fa-envelope"></span>
                      stusphere@gmail.com
                    </a>
                  </li>
                  <li>
                    <a href="#">
                      <span className="icon fa fa-map-marker"></span>Dehradun,
                      Uttarakhand, India
                    </a>
                  </li>
                </ul>

                {/* <!-- Button Box --> */}
                <div className="button-box d-lg-flex ">
                  <a
                    onClick={() =>
                      isLogined ? handleSignOut() : navigate("/auth/login")
                    }
                    className="btn clearfix login-btn"
                  >
                    <span className="btn-wrap">
                      <span className="text-one">
                        {isLogined ? "Sign-out" : "Login"}
                      </span>
                      <span className="text-two">
                        {isLogined ? "Sign-out" : "Login"}
                      </span>
                    </span>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* <!-- Header Lower --> */}
        <div className="header-lower">
          <div className="container">
            <div className="inner-container d-flex justify-content-between align-items-center">
              <div className="logo-box">
                {/* <!-- Logo --> */}
                <div className="logo">
                  <a href="/">
                    <img src="/images/logo-header.png" alt="img" title="" />
                  </a>
                </div>
              </div>
              <div className="nav-outer d-flex align-items-center">
                {/* <!-- Main Menu --> */}
                <nav className="main-menu d-none d-lg-block">
                  <div className="navbar-collapse collapse clearfix">
                    <ul className="navigation clearfix">
                      <li>
                        <Link to="/">Home</Link>
                      </li>
                      <li className="dropdown">
                        <Link>Products & Solutions</Link>
                        <ul>
                          <li>
                            <Link to="/admission-enrollment">
                              Admission & Enrollment
                            </Link>
                          </li>
                          <li>
                            <Link to="/student-information-system">
                              Student Information System (SIS)
                            </Link>
                          </li>
                          <li>
                            <Link to="/academic-management">
                              Academic Management
                            </Link>
                          </li>
                          <li>
                            <Link to="/administrative-console">
                              Administrative Console
                            </Link>
                          </li>
                          <li>
                            <Link to="/dynamic-website-for-schoolst">
                              Dynamic Website for Schoolst
                            </Link>
                          </li>
                          <li>
                            <Link to="/international-curriculum-development">
                              International Curriculum Development
                            </Link>
                          </li>
                          <li>
                            <Link to="/parent-management-system">
                              Parent Management System (PMS)
                            </Link>
                          </li>
                          <li>
                            <Link to="/hrms">
                              Human Resource Management System (HRMS)
                            </Link>
                          </li>
                          <li>
                            <Link to="/learning-management-system">
                              Learning Management System (LMS)
                            </Link>
                          </li>
                        </ul>
                      </li>
                      <li>
                        <Link to="/pricing">Pricing</Link>
                      </li>
                      <li>
                        <Link to="/blog">Blog</Link>
                      </li>
                      <li>
                        <Link to="/contact">Contact</Link>
                      </li>
                      {/* <li>
                        <Link to="/enrollment">Admission</Link>
                      </li> */}
                      <li>
                        <Link to="/faq">F&Q</Link>
                      </li>
                    </ul>
                  </div>
                </nav>
                {/* <!-- Main Menu End--> */}

                {/* <!-- Responsive Menu --> */}
                <button
                  className="mobileMenu-toggle d-lg-none d-block ms-3"
                  type="button"
                  data-bs-toggle="offcanvas"
                  data-bs-target="#offcanvasHome"
                  aria-controls="offcanvasHome"
                >
                  <i className="bi bi-list"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
        {/* <!-- End Header Lower --> */}
      </header>

      <AsideInfoBar
        handleAddCss={handleAddCss}
        isAdd={isAdd}
        data={ConsultancyAsideData}
      />
      <MobileNav />

      <Modal
        title="Confirm Logout"
        closable={{ "aria-label": "Custom Close Button" }}
        open={confirmSignOut}
        onOk={handleOk}
        onCancel={handleCancel}
        okText="Yes, Logout"
        cancelText="Cancel"
      >
        <p>Are you sure you want to Sign out?</p>
      </Modal>
    </>
  );
};

export default ConsultancyHeader;
